import { CartesianScaleTypeRegistry, Chart, registerables, ScaleOptionsByType } from 'chart.js';
import React from 'react';
import styled from 'styled-components';
import { _DeepPartialObject } from 'chart.js/types/utils';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(...registerables, ChartDataLabels);
export interface DataChart {
  labels: string[];
  datasets: {
    label?: string;
    data: string[] | number[];
    backgroundColor: string[];
    borderColor: string[];
    borderWidth?: number;
    hoverOffset?: number;
  }[];
}

interface ChartProps {
  type: 'bar' | 'doughnut';
  data: DataChart;
  scales: _DeepPartialObject<{ [key: string]: ScaleOptionsByType<keyof CartesianScaleTypeRegistry> }>;
  legend: boolean;
}
export const ChartView: React.FC<ChartProps> = ({ type, data, scales, legend }) => {
  const chartRef: any = React.createRef();

  React.useEffect(() => {
    let myChar: any = null;

    const myChartRef = chartRef.current.getContext('2d');

    myChar = new Chart(myChartRef, {
      type,
      data: data,
      options: {
        plugins: {
          legend: {
            display: legend,
          },
          tooltip: {
            enabled: type === 'bar',
          },
          datalabels: {
            color: 'grey',
            formatter: function (value) {
              if (Number(value) && type === 'doughnut') {
                return value + '%';
              }
              return '';
            },
          },
        },
        layout: {
          padding: {
            top: 20,
          },
        },
        scales: scales,
      },
    });

    return () => myChar.destroy();
  }, [chartRef, data, type, legend, scales]);
  return (
    <WrapperS>
      <canvas style={{ maxWidth: '500px', maxHeight: '300px' }} id="myChart" width="400" height="200" ref={chartRef} />
    </WrapperS>
  );
};

const WrapperS = styled.div`
  display: flex;
  margin-top: 120px;
  align-items: center;
  justify-content: center;
`;
